import React from 'react';
export function Footer() {
  return <footer className="bg-[#1a1a2e] text-white py-12 border-t border-white/10" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-92">
          <div className="col-span-1 md:col-span-2" data-id="element-93">
            <div className="flex items-center space-x-3 mb-4" data-id="element-94">
              <div className="w-8 h-8 rounded-full bg-[#d4a74a] flex items-center justify-center text-[#0f5f5f] font-serif font-bold text-lg" data-id="element-95">
                FG
              </div>
              <span className="text-white font-serif font-bold text-xl" data-id="element-96">
                Fair Gaming Space NGO
              </span>
            </div>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-97">
              Building a transparent, responsible, and fair gambling environment
              in Ukraine through research, advocacy, and support.
            </p>
          </div>

          <div data-id="element-98">
            <h4 className="font-bold text-lg mb-4 text-[#d4a74a]" data-id="element-99">
              Navigation
            </h4>
            <ul className="space-y-2" data-id="element-100">
              <li data-id="element-101">
                <a href="#home" className="text-gray-400 hover:text-white transition-colors" data-id="element-102">
                  Home
                </a>
              </li>
              <li data-id="element-103">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-104">
                  About Us
                </a>
              </li>
              <li data-id="element-105">
                <a href="#activities" className="text-gray-400 hover:text-white transition-colors" data-id="element-106">
                  Activities
                </a>
              </li>
              <li data-id="element-107">
                <a href="#news" className="text-gray-400 hover:text-white transition-colors" data-id="element-108">
                  News
                </a>
              </li>
              <li data-id="element-109">
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-110">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-111">
            <h4 className="font-bold text-lg mb-4 text-[#d4a74a]" data-id="element-112">Legal</h4>
            <ul className="space-y-2" data-id="element-113">
              <li data-id="element-114">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-115">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-116">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-117">
                  Terms of Use
                </a>
              </li>
              <li data-id="element-118">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-119">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-120">
          <p className="text-gray-500 text-sm" data-id="element-121">
            © {new Date().getFullYear()} Fair Gaming Space NGO. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-122">
            <span className="text-gray-500 text-sm" data-id="element-123">Designed for Impact</span>
          </div>
        </div>
      </div>
    </footer>;
}